import { render, staticRenderFns } from "./JianLi.vue?vue&type=template&id=75fdc638&scoped=true&"
import script from "./JianLi.vue?vue&type=script&lang=js&"
export * from "./JianLi.vue?vue&type=script&lang=js&"
import style0 from "./JianLi.vue?vue&type=style&index=0&id=75fdc638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fdc638",
  null
  
)

export default component.exports